import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface EyebrowProps {
  children: ReactNode;
  color?: "bronze" | "cream";
  className?: string;
  align?: "left" | "center";
}

export function Eyebrow({
  children,
  color = "bronze",
  className,
  align = "left",
}: EyebrowProps) {
  const text = color === "cream" ? "text-cream-50" : "text-bronze-600";
  const rule = color === "cream" ? "bg-bronze-400/60" : "bg-bronze-600/60";

  return (
    <div
      className={cn(
        "flex items-center gap-3",
        align === "center" && "justify-center",
        className,
      )}
    >
      <span className={cn("h-px w-8", rule)} aria-hidden />
      <span
        className={cn(
          "font-sans text-[11px] font-semibold uppercase tracking-[0.22em]",
          text,
        )}
      >
        {children}
      </span>
      <span className={cn("h-px w-8", rule)} aria-hidden />
    </div>
  );
}

export default Eyebrow;